import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processBusinessUseData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const processedBusinessUseData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const businessPercentage = vehicle?.business_use_percentage || 0;

      const isValid = validateFailedObjects(index, validation);

      const numValue =
        typeof businessPercentage === 'string'
          ? parseFloat(businessPercentage)
          : businessPercentage;

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        businessPercentage: numValue,
        remarks: remarks.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
        isValid,
      };
    }),
  };

  const validationData = processValidation(validation);

  return {
    title: 'Business use',
    description: 'Track percentage of business usage for each vehicle.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: processedBusinessUseData,
  };
};
